import React, { useState, memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/zoomElem.styles'
import Button from '@material-ui/core/Button'
import FadeInHOC from '../FadeInHOC'
import { useMediaQuery } from '@material-ui/core'
import { DecorazioniPageConfig } from '../../configuration'
import { SvoltaPageConfig } from '../../configuration'

const useStyles = makeStyles(styles)

function ImageZoom({ url, url_mobile }) {
    // state
    const [zoomedIn, setZoomedIn] = useState(true)
    const handleClick = () => {
        setZoomedIn(!zoomedIn)
    }
    // styles
    const props = {
        zoomedIn
    }
    const classes = useStyles(props)
    // conditional render as css order doesnt work in this example as it is inside a div
    const isMobile = useMediaQuery('(max-width: 760px)')
    return (
        <>
            <FadeInHOC rootClass={classes.root} div >
                <img className={classes.img} src={isMobile ? url_mobile : url} alt='affrescati' />
                {!isMobile && <Button onClick={handleClick} className={classes.button} >
                    {!zoomedIn ? SvoltaPageConfig.zoom.cta[0] : SvoltaPageConfig.zoom.cta[1] }
                </Button>}
            </FadeInHOC>
            {isMobile && <Button onClick={handleClick} className={classes.mobileBtn} >
               { !zoomedIn ? SvoltaPageConfig.zoom.cta[0] : SvoltaPageConfig.zoom.cta[1] }
            </Button>}
        </>
    )
}

export default memo(ImageZoom)